import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import Drop from 'hb-builder/components/common/Drop';
import { useBuilderConfigContext } from 'hb-builder/hooks';
import { BUILDER_DOCUMENT_CHILDREN_TYPE } from 'hb-react/backoffice/types/builder/builderDocument';

const componentType = BUILDER_DOCUMENT_CHILDREN_TYPE.EMPTY_DOCUMENT_PLACEHOLDER;

const EmptyDocumentPlaceholder = () => <div />; // never used

const RenderBuilder = () => {
  const {
    translationKeys: { emptyDocument: emptyDocumentText },
  } = useBuilderConfigContext();

  return (
    <Drop
      accept={['section', 'structure', 'single']}
      placeholderPositions={['top']}
    >
      {({ isOver }) => (
        <EmptyWrapper data-testid="builder-empty-document" $isOver={isOver}>
          {emptyDocumentText}
        </EmptyWrapper>
      )}
    </Drop>
  );
};

const Render = () => null;

EmptyDocumentPlaceholder.componentName =
  BUILDER_DOCUMENT_CHILDREN_TYPE.EMPTY_DOCUMENT_PLACEHOLDER;
EmptyDocumentPlaceholder.componentType = componentType;
EmptyDocumentPlaceholder.componentCategory = 'simple';

EmptyDocumentPlaceholder.canBeDoubleClicked = false;
EmptyDocumentPlaceholder.canBeDragged = false;
EmptyDocumentPlaceholder.canBeListed = false;
EmptyDocumentPlaceholder.canBeSelected = false;

EmptyDocumentPlaceholder.RenderBuilder = RenderBuilder;
EmptyDocumentPlaceholder.Render = Render;

EmptyDocumentPlaceholder.item = () => null;

export default EmptyDocumentPlaceholder;

interface EmptyWrapperProps {
  $isOver: boolean;
}

const EmptyWrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  height: '500px',
  justifyContent: 'center',
}))<EmptyWrapperProps>`
  opacity: ${({ $isOver }) => ($isOver ? 0.6 : 1)};
`;
